/** Field keys used by the Maps Lead Extraction backend responses. */

export const PLACE_PREVIEW_KEYS = Object.freeze({
    id: Object.freeze(['id']),
    name: Object.freeze(['name', 'official_name']),
    lat: Object.freeze(['lat']),
    lng: Object.freeze(['lng', 'lon']),
    category: Object.freeze(['category', 'type']),
    dist: Object.freeze(['dist']),
    phone: Object.freeze(['phone']),
    website: Object.freeze(['website']),
    street: Object.freeze(['street', 'location']),
    city: Object.freeze(['city']),
    postal: Object.freeze(['postal']),
    country: Object.freeze(['country']),
    dataQualityScore: Object.freeze(['data_quality_score']),
    email: Object.freeze(['email']),
    potentialDuplicate: 'potential_duplicate',
});

export const PLACE_ENRICHED_ITEM_KEYS = Object.freeze({
    entity: 'entity',
    entityAccounts: 'accounts',
    enhancementFailed: 'enhancementFailed',
    enhancementError: Object.freeze(['enhancementError']),
    params: 'params',
    type: 'type',
    typeForm: 'form',
});

export const PLACE_ACCOUNT_FORM_PARAMS_KEYS = Object.freeze({
    address1: Object.freeze(['address1']),
    address2: Object.freeze(['address2']),
    category: Object.freeze(['category']),
    city: Object.freeze(['city']),
    comment: Object.freeze(['comment']),
    country: Object.freeze(['country']),
    email: Object.freeze(['email']),
    name: Object.freeze(['name']),
    phone: Object.freeze(['phone']),
    postcode: Object.freeze(['postcode']),
    region: Object.freeze(['region']),
    vatNumber: Object.freeze(['vatNumber']),
    warningText: Object.freeze(['warningText']),
    web: Object.freeze(['web']),
});

export function pickString(record, orderedKeys) {
    if (!record || typeof record !== 'object') return '';
    for (const key of orderedKeys) {
        const value = record[key];
        if (value === undefined || value === null) continue;
        const str = String(value);
        if (str) return str;
    }
    return '';
}
